"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'ProfileEdit',
  props: {
    initialData: {
      type: Object,
      default: () => ({
        name: '',
        handle: '',
        bio: '',
        bannerColor: '#ff00cc',
        avatar: ''
      })
    }
  },
  data() {
    return {
      editMode: 'public',
      profileData: {
        ...this.initialData
      },
      anonymousData: {
        user: 'Admin_User',
        anon_nick: 'Anon_Sombra'
      }
    };
  },
  methods: {
    saveChanges() {
      this.$emit('save', this.profileData);
      alert('¡Cambios guardados con éxito!');
    }
  }
};